import {Component, EventEmitter, Output} from '@angular/core';
import {
  PortNumberBlockDetails,
} from '../../port-phonenumber.model';
import {MessageService} from 'primeng/api';
import {I18NextService} from 'angular-i18next';
import {FormEmitter} from "../../../forms/form.component";

@Component({
    selector: 'app-phonenumber-port-single-number',
    templateUrl: './phonenumber-port-single-number.component.html',
    standalone: false
})
export class PhonenumberPortSingleNumberComponent {

  private readonly MAX_SELECTABLE_SINGLE_PHONE_NUMBERS = 10;

  @Output() public readonly selected = new EventEmitter<PortNumberBlockDetails[]>();
  @Output() public readonly onBack = new EventEmitter();

  public singlePhoneNumbers: PortNumberBlockDetails[] = [];
  public areaCode: string;

  constructor(public messageService: MessageService,
              public i18next: I18NextService) {
  }

  onSubmit(form: FormEmitter<PortNumberBlockDetails>) {
    const number = form.data;
    if (this.singlePhoneNumbers.length < this.maxSelectableSingleNumbers) {
      this.areaCode = number.area_code;

      for (const existingNumber of this.singlePhoneNumbers) {
        if (number.format() === existingNumber.format()) {
          this.messageService.add({severity: 'error',
            summary: this.i18next.t('port_number_already_selected_error_title') as string,
            detail: this.i18next.t('port_number_already_selected_error_description') as string});
          return;
        }
      }

      this.singlePhoneNumbers.push(number);
      form.formGroup.get('number').reset();
    } else {
      this.messageService.add({severity: 'error',
        summary: this.i18next.t('port_number_max_selected_error_title',
          { max: this.maxSelectableSingleNumbers }) as string,
        detail: this.i18next.t('port_number_max_selected_error_description',
          { max: this.maxSelectableSingleNumbers }) as string
      });
    }
  }

  removeSingleNumber(id: number) {
    this.singlePhoneNumbers.splice(id, 1);

    if (this.singlePhoneNumbers.length === 0) {
      this.areaCode = undefined;
    }
  }

  public back() {
    this.onBack.emit();
  }

  public next() {
    const numbers = this.singlePhoneNumbers;
    this.selected.emit(numbers);
  }

  public get formDisabled() {
    return this.singlePhoneNumbers.length === 0;
  }

  public get maxSelectableSingleNumbers() {
    return this.MAX_SELECTABLE_SINGLE_PHONE_NUMBERS;
  }
}
